export const COLLECTION = {
  seo_setting: "seo_setting",
  seo_advanced: "seo_advanced_setting",
  seo_detail: "seo_detail",
  seo_redirection: "seo_redirection",
  language: "languages"
};
export const FIELDS = {
  seo_detail: "seo_detail"
};
